import { EvaluationMeasurement } from 'app/assessment/evaluation/models/evaluation-measurement.enum';

export function mapEvaluationMeasurement(value: string): string {
  switch(value) {
    case EvaluationMeasurement.WORKSPACE:
      return '$evaluation_desk_evaluation_employee_workspace_measurements_label';
    case EvaluationMeasurement.DESK_HEIGHT:
      return '$evaluation_desk_evaluation_desk_height_label';
    case EvaluationMeasurement.MONITOR_HEIGHT:
      return '$evaluation_desk_evaluation_monitor_height_label';
    case EvaluationMeasurement.FOCAL_DISTANCE:
      return '$evaluation_desk_evaluation_focal_distance_label';
    case EvaluationMeasurement.REACH_TO_PHONE:
      return '$evaluation_desk_evaluation_reach_to_phone_label';
    case EvaluationMeasurement.CUSTOM:
      return '$evaluation_desk_evaluation_custom_measurements_label';
    default:
      return undefined;
  }

}
